import { Outlet } from "react-router-dom";
import UserProtectedRoutes from "./UserProtectedRoutes";

interface UserProtectedParentProps {}

const UserProtectedParent = ({}: UserProtectedParentProps) => {
  return (
    <UserProtectedRoutes>
      <Outlet />
    </UserProtectedRoutes>
  );
};

export default UserProtectedParent;
